import { __assign, __rest } from "tslib";
// Disabling this since the props spread should contain `children
// Not adding children explicitly to avoid unintentionally changing the API of this component
// Ideally, children would be marked as required on this component
/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import { useBiClickLogger } from '../hooks/useBiClickLogger';
var BiLink = function (_a) {
    var biData = _a.biData, dispatch = _a.dispatch, innerRef = _a.innerRef, stopPropagation = _a.stopPropagation, props = __rest(_a, ["biData", "dispatch", "innerRef", "stopPropagation"]);
    var setTrackingRef = useBiClickLogger(biData, stopPropagation).setTrackingRef;
    if (props.target === '_blank' && !props.rel) {
        props.rel = 'noreferrer';
    }
    return (React.createElement("a", __assign({}, props, { ref: function (node) {
            setTrackingRef(node);
            innerRef && innerRef(node);
        } })));
};
BiLink.displayName = 'BiLink';
export default BiLink;
//# sourceMappingURL=BiLink.js.map